import React from "react";
import styled from "styled-components";
import {
  CheckboxContainer,
  CheckboxLabel,
  HeaderSection,
  MainContainer,
} from "../index.styled";
import { ReactComponent as Ribbon } from "../../../Assets/Icons/Ribbon.svg";
import { viewSizeCalculator } from "../../../utils";

const OncologyFocus = ({ data, reference }) => {
  const fields = data.fields;

  // Render a single checkbox
  const renderCheckbox = (field, index) => (
    <CheckboxContainer key={index}>
      <input
        style={{
          cursor: "pointer",
          accentColor: "#F96250",
          width: viewSizeCalculator(1.063),
          height: viewSizeCalculator(1.063),
        }}
        type="checkbox"
        id={field.label}
      />
      <CheckboxLabel htmlFor={field.label}>{field.label}</CheckboxLabel>
    </CheckboxContainer>
  );

  // Render a row of checkboxes
  const renderRow = (startIndex, endIndex) => (
    <tr key={startIndex}>
      {fields.slice(startIndex, endIndex).map((field, index) => (
        <Td key={startIndex + index}>
          {renderCheckbox(field, startIndex + index)}
        </Td>
      ))}
    </tr>
  );

  // Render all rows dynamically
  const renderTable = () => {
    const rows = [];
    for (let i = 0; i < fields.length; i += 3) {
      rows.push(renderRow(i, i + 3));
    }
    return rows;
  };

  return (
    <MainContainer ref={reference}>
      <HeaderSection>
        <Ribbon />
        {data.category}
      </HeaderSection>
      <ContentWrapper>
        <Table>
          <tbody>{renderTable()}</tbody>
        </Table>
      </ContentWrapper>
    </MainContainer>
  );
};

export default OncologyFocus;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const Table = styled.table`
  width: 80%;
`;

const Td = styled.td`
  padding-bottom: 1.25rem;
`;
